//require some deps that included from index.scala.html
require('main.less');
require('mobile/mobile.less');

//add html to templace cache
angular.module('templates', []);
require('top-layout.html');
require('tabs.html');
require('search.html');
require('modal-template.html');
require('landing/landing-new.html');
require('explore.html');
require('project-item.html');
require('projects.html');
require('news.html');
require('user-page.html');
require('search-page.html');
require('user-popup.html');
// require('landing/landing-top-footer.html');
require('project/project.html');

require('favicon.ico');

function getMainView() {
    return <HTMLElement>document.querySelector('.main[ui-view]');
}

function showErrorPage() {
    const oReq  = new XMLHttpRequest();
    oReq.onload = function () {
        document.querySelector('.wrapper').classList.add('wrapper-not-found');
        getMainView().innerHTML = (this as XMLHttpRequest).responseText;
    };
    oReq.open('get', require('404.html'), true);
    oReq.send();
}

window.onerror = function (msg, url, lineNumber, column, err) {
    if (msg.indexOf('c.apply is not a function') > -1) {
        console.error('Unable to load file, check paths');
    }
    if (options && !options.isProduction && options.debugger) {
        debugger;
    }
    console.log(arguments);
    console.error(err || msg);
    if (!getMainView().innerHTML) {
        showErrorPage();
    }
    return true;
};

if (window.Raven && window.console) {
    Raven.setTagsContext({build: options.buildNumber});
    const originalError   = console.error;
    const originalConsole = console;
    window.console.error  = function (err) {
        const args = [].slice.call(arguments);

        const msg  = '' + args.join(' ');
        const data = {level: 'error', logger: 'console', extra: {'arguments': args}};
        if (err instanceof Error) {
            Raven.captureException(err, data);
        } else {
            Raven.captureMessage(msg, data);
        }
        if (_.notification && options && !options.isProduction) {
            _.notification.showError('Exception: ' + msg.substring(0, 200));
        }
        Function.prototype.bind
            .call(originalError, originalConsole)
            .apply(originalConsole, args);
    };
}


if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (this: string, searchString: string, position = 0) {
        return this.indexOf(searchString, position) === position;
    };
}
if (!Array.prototype.includes) {
    Array.prototype.includes = function (this: any[], el: any) {
        return this.indexOf(el) !== -1;
    };
}
if (!String.prototype.includes) {
    String.prototype.includes = function (this: string, el: string) {
        return this.indexOf(el) !== -1;
    };
}

if (typeof Object.assign !== 'function') Object.assign = _.extend;

Object.defineProperty && Object.defineProperty(window, '_', {
    value: _,
    writable: false
});


try {
    const n = (navigator as any).storage;
    n && n.persist && n.persist().catch((e: any) => _.noop);
} catch (e) {}

const createScriptEl = (src: string) => {
    const node   = document.getElementsByTagName('head')[0] || document.body;
    const script = document.createElement('script');

    script.type  = 'text/javascript';
    script.async = true;
    script.src   = src;

    node.appendChild(script);

    return script;
};

const cachePromise = {};
const requirejs    = (modules: any[], callback: any, err: any) => {
    return Promise.all(modules.filter(m => m).map(m => {
            const getPromise = () => new Promise((resolve, reject) => {
                const script  = createScriptEl(m);
                script.onload = (script as any).onreadystatechange = () => resolve();
                script.onerror = reject;
            });

            if (!cachePromise[m]) {
                cachePromise[m] = getPromise();
            }

            return cachePromise[m];
        }
    )).then(callback).catch(err);
};

window.loadScripts = (modules: string[], callback: Function, silentFail = false) => {
    const load = (retries: number) => requirejs(modules, callback, (err: any) => {
        if (silentFail) return;
        const failedId = err.requireModules && err.requireModules[0];
        // requirejs.undef(failedId);

        const query  = `script[data-requiremodule="${failedId}"]`;
        const script = document.querySelector(query);
        if (script) script.parentNode.removeChild(script);
        if (retries >= 5) {
            console.error(err);
            callback(err);
        } else {
            console.log('Error loading, retrying', failedId);
            setTimeout(() => load(retries + 1), 500 * (retries + 1));
        }
    });
    load(0);
};

import 'angular-cookie';
import 'loading-bar';
import 'ocLazyLoad';
import 'app';



// WEBPACK FOOTER //
// ./app/assets/javascripts/main.ts